import { THEMES } from '@/styles/themes';
import { useUiStore } from '@/store/uiStore';
import '@/styles/pages/settings.css';

const THEME_BLURB: Record<(typeof THEMES)[number]['id'], string> = {
  light: 'Classic light theme',
  dark: 'Best for focus',
  auto: 'Follows device settings',
};

const THEME_PREVIEW_ICON: Record<(typeof THEMES)[number]['id'], string> = {
  light: 'bi-sun',
  dark: 'bi-moon',
  auto: 'bi-display',
};

export default function AppearanceSection() {
  const { theme, setTheme } = useUiStore();

  return (
    <section className="settings-card">
      <header className="settings-card__head">
        <div>
          <h2 className="settings-card__title">Theme</h2>
          <p className="settings-card__sub">Choose how you want the app to look.</p>
        </div>
      </header>

      <div className="settings-theme-grid">
        {THEMES.map((t) => {
          const isActive = theme === t.id;
          return (
            <button
              key={t.id}
              type="button"
              className={`btn-unstyled settings-theme-card${isActive ? ' is-active' : ''}`}
              onClick={() => setTheme(t.id)}
              aria-pressed={isActive}
              aria-label={`${t.label} theme. ${THEME_BLURB[t.id]}`}
            >
              <div className={`settings-theme-preview settings-theme-preview--${t.id}`}>
                <i className={`bi ${THEME_PREVIEW_ICON[t.id]}`} aria-hidden="true" />
              </div>
              <span className="settings-theme-meta">
                <span className="settings-theme-label">{t.label}</span>
                {isActive && (
                  <span className="settings-theme-check" aria-hidden="true">
                    <i className="bi bi-check-lg" />
                  </span>
                )}
              </span>
              <span className="settings-theme-blurb">{THEME_BLURB[t.id]}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
